import * as React from "react";
import ReactDOM from "react-dom/client";
import { Global } from "@emotion/react";
import { GlobalStyles as BaseStyles } from "twin.macro";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import moengage from "@moengage/web-sdk";

import "react-toastify/dist/ReactToastify.min.css";

import App from "app";
import reportWebVitals from "./reportWebVitals";

import GlobalStyles from "app/styles";
import {
  BUSHA_ENV,
  MOENGAGE_APP_ID,
  SENTRY_DSN,
} from "app/constants/variables";

Sentry.init({
  environment: BUSHA_ENV,
  dsn: SENTRY_DSN,
  integrations: [new BrowserTracing()],
  enabled: process.env.NODE_ENV === "production",
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: process.env.NODE_ENV === "development" ? 0 : 0.5,
});

moengage.initialize({
  app_id: MOENGAGE_APP_ID,
  cluster: "DC_2",
  enableSPA: true,
  debug_logs: BUSHA_ENV === "production" ? 0 : 1,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BaseStyles />
    <Global styles={GlobalStyles} />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
